<template>
   
<PrimeBreadcrumb  :home="home" :model="items" style="margin-top: 0px;"></PrimeBreadcrumb>
  <form @submit.prevent="save">
    <div class="p-fluid">
      <div class="p-field">
        <div class="row">
          <div class="col-3">
              <my-text-single
              v-model="my_item.year"
              :label="'年度'"
              :required="true"
              :maxlength="4"
            ></my-text-single> 
         </div>
          <div class="col-3">
            <my-text-single
              v-model="my_item.hcTedelno_Start_9"
              :label="'起始編號'"
              :required="true"
              :maxlength="3"
            ></my-text-single>
          </div>
        
          <div class="col-3">
            <my-text-single
              v-model="my_item.hcTedelno_End_9"
              :label="'結束編號'"
              :required="true"
              :maxlength="3"
            ></my-text-single>
         </div>
         <div class="col-3">
           <my-text-single
              v-model="rangenumber"
              :label="'總數'"
              :required="true"
              :disabled="true"
            ></my-text-single>
             
<PrimeButton
          label="開啟客戶預取號"
          icon="pi pi-check"
          class="p-button-success"
          @click="open()"
        />
<PrimeButton
          label="區間號使用狀況"
          icon="pi pi-check"
          class="p-button-primary"
          @click="open2()"
        />

         </div>
           
        </div>
      </div>
       
    </div>
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2">
        <PrimeButton
          label="Cancel"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="closeModal()"
        />
      </div>
      <div class="col-2">
        <PrimeButton
          type="submit"
          label="Save"
          icon="pi pi-check"
          class="p-button-primary"
        />
      </div>
    </div>
  </form>

 
 <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    :style="{ width: '950px' }"
    header="客戶預取號"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name"
      :parentpkey="my_item.pkey"
      :minno="my_item.hcTedelno_Start_9"
      :maxno="my_item.hcTedelno_End_9"

      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>

<!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog2"
    :style="{ width: '950px' }"
    header="區間號使用狀況"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name2"
      :parentpkey="my_item.pkey"
        :custparentpkey="custparentpkey"
     ></component>
  </PrimeDialog>


</template>


<script>
import service from "../service/Appservice";

export default {
  props: ["item"],
  data() {
    return {
      component_name: "my-agent-cust-hctedelno-range",
      component_name2: "my-hctedelno",
      isShowDialog: false,
      isShowDialog2: false,
      custparentpkey:0,
       my_item: { 
       },
        home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: '代理'} ,
                {label: '代理維護'} ,
                {label: '代理區間號'}, 
                {label: '代理區間號維護'} 
            ]
    };
  },
  computed: {
   
    user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
     rangenumber() {
      return this.my_item.hcTedelno_End_9 - this.my_item.hcTedelno_Start_9 + 1;
    },
  },
  service: null,
  created() {
    this.my_item = this.item ;
    console.log('created')
    console.log(this.my_item)
    this.service = new service();
  },
   
  methods: {
     open() {
       this.isShowDialog = true;
    },
      open2() {
       this.isShowDialog2 = true;
    },
    closeModal() {
      this.$emit("close");
    },
    save() {
    
      var self = this;

      self.my_item.createTime = new Date().toISOString();
      self.my_item.updateTime = new Date().toISOString();
      self.my_item.clientId = self.clientId;
 
      this.service.updateAgentHCTedelnoRange(this.my_item).then((data) => {
        self.my_item = data;
        self.$emit("save", data);
        self.$emit("itemsavedone", self.my_item);
      });
    },
  },
};
</script>